import { render, staticRenderFns } from "./LabInvoiceDetailTable.vue?vue&type=template&id=b2495528&scoped=true&"
import script from "./LabInvoiceDetailTable.vue?vue&type=script&lang=js&"
export * from "./LabInvoiceDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./LabInvoiceDetailTable.vue?vue&type=style&index=0&id=b2495528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2495528",
  null
  
)

export default component.exports